import { transitionBiddingIntradayOrderState } from '@ebalance/proto/bffuser/v1/bidding_intraday_service-BiddingIntradayService_connectquery'

import { biddingQueryKeys } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 時間前注文 ステータス遷移 mutation hook (楽観ロック使用)。
 * intraday では全 action (REQUEST / APPROVE / REJECT / CANCEL / SUBMIT / WITHDRAW /
 * REOPEN) が有効 (REOPEN = 差戻し後再編集、 AC-BIN-049)。 提出・取消で変わる板発注の
 * コマリボンの件数 (AC-BIN-025) も、 5 秒ごとの取り直しを待たずに取り直す。
 */
export function useTransitionBiddingIntradayOrderState(): InvalidatingMutationResultFor<
  typeof transitionBiddingIntradayOrderState
> {
  return useWorkflowCaseScopedMutation(
    useInvalidatingMutation(transitionBiddingIntradayOrderState, [
      biddingQueryKeys.intradayList,
      biddingQueryKeys.intradayDetail,
      biddingQueryKeys.intradayActiveOrderCounts,
    ]),
  )
}
